import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export const displayNameFromEmail = (email: string | null | undefined) => {
  if (!email) return "—";
  const local = email.split("@")[0] || email;
  return local
    .split(/[._-]/)
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(" ");
};

export const initials = (
  name: string | null | undefined,
  email: string | null | undefined
) => {
  const source = (name && name.trim()) || displayNameFromEmail(email);
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return source.slice(0, 2).toUpperCase();
};

interface Props {
  user_email: string;
  user_name?: string | null;
  image?: string | null;
  size?: "sm" | "md";
  className?: string;
}

const SIZE_MAP = {
  sm: { avatar: "h-6 w-6", text: "text-xs" },
  md: { avatar: "h-8 w-8", text: "text-sm" },
} as const;

const UserCell: React.FC<Props> = ({
  user_email,
  user_name,
  image,
  size = "sm",
  className = "",
}) => {
  const sizes = SIZE_MAP[size];
  const name = user_name?.trim() || displayNameFromEmail(user_email);
  return (
    <div className={`flex items-center gap-2 min-w-0 ${className}`}>
      <Avatar className={`${sizes.avatar} flex-shrink-0`}>
        {image ? <AvatarImage src={image} alt={name} /> : null}
        <AvatarFallback className="bg-[#334238] text-[#dbf566] text-[10px] font-semibold">
          {initials(user_name, user_email)}
        </AvatarFallback>
      </Avatar>
      <span
        className={`${sizes.text} text-gray-700 truncate`}
        title={user_email}
      >
        {name}
      </span>
    </div>
  );
};

export default UserCell;
